import React from "react";
import AISuggestionDisplay from "./AISuggestionDisplay";
import { useAISuggestion } from "@utils/useAiSuggestion";

const AISuggestion = ({ fitnessData, dateRange }) => {
  const { aiResponse, generateAISuggestion } = useAISuggestion(fitnessData, dateRange);

  return (
    <AISuggestionDisplay
      aiResponse={aiResponse}
      onRegenerate={generateAISuggestion}
      showRegenerateButton={false}
    />
  );
};

export default AISuggestion;